import React from 'react';
import {observer} from "mobx-react-lite";
import {useServices} from "../../../../react-hooks/use-services.hook";
import {HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent} from "../../../header/welcome-buttons/authorized-user/mobile-view/header-welcome-buttons-for-authorized-user-mobile-view.component";
import {VideoSlidesArenaHeaderBox} from "./boxes/video-slides-arena-header.box";
import {VideoSlidesArenaFiltersIndicator} from './components/video-slides-arena-filters-indicator/video-slides-arena-filters-indicator.component';
import {VideoSlideRegulatoryDataComponent} from './boxes/video-slide-regulatory-data-component.box';
import {
    VideoSlidesUserMenuButtonBox
} from "./components/video-slides-header-filter-button/video-slides-user-menu-button.box";
import {
    IVideoSlidesFilter
} from "../../../../services/configurations/config-data-sections/arenas.configuration";

export interface VideoSlidesHeaderArenaProps {
    filters: IVideoSlidesFilter[];
}

export const VideoSlidesHeaderArena: React.FC<VideoSlidesHeaderArenaProps> = observer((props) => {
    const services = useServices();

    const renderHeaderWelcomeButtonsForAuthorizedUserMobile = () => {
        if (services.user.isAuthorized) {
            return (
                <VideoSlidesUserMenuButtonBox>
                    <HeaderWelcomeButtonsForAuthorizedUserMobileViewComponent />
                </VideoSlidesUserMenuButtonBox>
            );
        }
    }

    return (
        <>
            <VideoSlideRegulatoryDataComponent attachToHeaderService={true} />
            <VideoSlidesArenaHeaderBox>
                <VideoSlidesArenaFiltersIndicator filters={props.filters}/>
                {renderHeaderWelcomeButtonsForAuthorizedUserMobile()}
            </VideoSlidesArenaHeaderBox>
        </>
    );
})